export default __webpack_public_path__ + "static/media/bhim.3d0b0040.svg";